import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=2946402a&"
import script from "./Debug.vue?vue&type=script&lang=ts&"
export * from "./Debug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports